import React from "react";
import "./styles.css";
import BackToHome from "../../components/backToHome";

const privacyPolicy = `
<h2>Privacy Policy</h2>
<h3>1. Who is responsible</h3>
<p>Universedecoder operates Muscle Up (the “App”) and is responsible for the personal data processing described here. Legal operator and business form: Universedecoder. Address: Plot 20, Vaibhav Anand Society, Shambhunagar, Faras, Nagpur, Maharashtra, India, 440030. Email: <a href="mailto:srushtee@universedecoder.in">srushtee@universedecoder.in</a>.</p>
<p>Privacy and grievance contact: Srushtee Satardey, Founder, at the email and postal address above. </p>
<h3>2. Scope and private records</h3>
<p>This Policy explains how we collect, use, disclose, retain and delete personal data in connection with the App, subscription support and related communications. Account and fitness information is stored on servers. Your records are private in the sense that the current App does not make them available to other users through public posts, messaging or public sharing. Necessary access by us and authorised service providers is described below; “private” does not mean that no provider can process your data.</p>
<h3>3. Information we process</h3>
<ul>
<li>
  <strong>Account information:</strong>
  When you register using email, we collect your username,
  email address and password for account creation and authentication.
  When you sign in using Google, we receive your name and email
  address from Google. We do not receive your Google password.
  Account information is used to create and manage your account,
  authenticate access and provide account-related communications.
</li>
<li>
  <strong>Optional AI Coach information:</strong>
  If you choose to use AI Coach, we process the personal fitness
  goals, experience level, number of workout days requested and
  injury-prone areas you enter to generate a personalised workout
  plan. When you
  choose to add that plan to your week planner, we store it
  against your account.
</li>
<li>
  <strong>Payments and subscriptions:</strong>
  Google Play handles subscription payments. We do not receive
  your payment-card or bank-account details, and we do not use
  another billing provider. We process subscription information
  received from Google Play as necessary to verify your purchase,
  manage access to paid features and resolve billing-related
  support requests. Google processes your payment information
  under its own privacy policy.
</li>
<li><strong>Support information:</strong> the content of emails, deletion requests, feedback and attachments you send, together with information needed to respond or verify the request.</li>
<li>
  <strong>Analytics and device tracking:</strong>
  We do not currently use analytics tools or track your device
  for advertising purposes.
</li>
</ul>
<p>Data comes from you, your use of the service and the providers identified below. Do not submit someone else's personal information without a lawful basis. We do not need unnecessary medical details for general fitness personalisation. Where an enabled feature collects information revealing health status, that information may receive additional protection under applicable law.</p>
<h3>4. Purposes and legal grounds</h3>
<ul>
<li><strong>Account and service delivery:</strong> to register and authenticate you, store private records, generate requested workouts and provide subscribed features. Where applicable, the legal ground is performance of our contract or steps taken at your request before contracting.</li>
<li><strong>Billing and support:</strong> to confirm entitlements, handle subscription issues and answer service requests; where applicable, contract performance and relevant legal obligations.</li>
<li><strong>Security and abuse prevention:</strong> to investigate misuse and protect accounts and systems. Where applicable, legitimate interests in a secure service, balanced against your rights, or a legal obligation.</li>
<li><strong>Compliance and claims:</strong> to maintain legally required records, respond to lawful requests and establish or defend legal claims, using the applicable legal obligation or other permitted legal ground.</li>
<li><strong>Optional processing:</strong> non-essential tracking, marketing or other optional uses will use consent where required. </li>
</ul>
<p>Where local law requires consent for a use, we will obtain the required consent rather than rely on a ground unavailable under that law. Where health information requires an additional legal condition, such as explicit consent, that condition must also be satisfied. Accepting the Terms or reading this Policy does not itself provide consent to every use.</p>
<p>Required account and personalisation fields are identified when collected; without necessary information we may be unable to provide the corresponding service. Optional fields may be skipped without losing unrelated functionality. Withdrawing consent may prevent the particular optional processing or feature from continuing, but does not affect earlier lawful processing.</p>
<h3>5. AI and workout generation</h3>
<p>We use your fitness goals and the other relevant inputs identified above to generate personalised workouts using automated and AI-assisted processing. This is fitness personalisation, not a clinical assessment.</p>
<p><strong>AI provider and data handling.</strong> AI Coach uses OpenAI through Emergent's AI integration. Processing takes place on external service infrastructure and involves sending information to the United States. Information sent includes your fitness goals, experience level, requested training days and any injuries or injury-prone areas you enter. Requests also include your internal Muscle Up user ID. Your name and email address are not included in the AI prompts. Injury information may constitute health-related personal data.</p>

<p>
  AI exercise suggestions also use OpenAI through Emergent.
  These requests include the muscle name and your internal
  Muscle Up user ID. Generated AI Coach plans are stored
  in your account's plan history. You can choose whether
  to add a generated plan to your week planner.
</p>

<p>
  AI Coach automatically uses your inputs to personalise
  workout recommendations. These recommendations are
  general fitness suggestions, not medical assessments,
  injury treatment or a determination that an exercise
  is safe for you.
</p>

<p>
  You choose whether to use AI Coach and what information
  to submit. For questions about AI processing or to
  request deletion of associated personal data, contact
  <a href="mailto:srushtee@universedecoder.in">
    srushtee@universedecoder.in
  </a>.
  Provider information is available in the
  <a href="https://app.emergent.sh/privacy-policy"
     target="_blank" rel="noopener noreferrer">
    Emergent Privacy Policy
  </a>
  and the
  <a href="https://openai.com/policies/privacy-policy/"
     target="_blank" rel="noopener noreferrer">
    OpenAI Privacy Policy
  </a>.
</p>
<h3>6. Recipients and service providers</h3>
<p>Personal data may be processed by providers supplying hosting, database, authentication, AI generation, payment entitlement verification, security and support, only for the functions actually used. We do not claim that all disclosures are anonymous.</p>
<ul>
<li>
  <strong>Hosting and database:</strong>
  We use Emergent-managed hosting to operate the Application's
  backend and MongoDB Atlas, provisioned through Emergent,
  to store application data. These services process account
  information, authentication records, workout history,
  weekly plans, AI Coach plans and inputs, subscription-related
  records and password-reset information as needed to provide
  the Application.
  <a href="https://app.emergent.sh/privacy-policy"
     target="_blank" rel="noopener noreferrer">
    Emergent Privacy Policy
  </a>
  |
  <a href="https://www.mongodb.com/legal/privacy-policy"
     target="_blank" rel="noopener noreferrer">
    MongoDB Privacy Policy
  </a>
</li>

<li>
  <strong>Payments and subscription management:</strong>
  Google Play processes subscription payments. We do not
  receive your payment-card or bank-account details.
  We use RevenueCat to support subscription verification
  and management of access to paid features. RevenueCat
  processes app user identifiers and purchase-related
  information for these purposes.
  <a href="https://www.revenuecat.com/privacy"
     target="_blank" rel="noopener noreferrer">
    RevenueCat Privacy Policy
  </a>
</li>
<li>
  <strong>Authentication:</strong>
  You can create an account using a username, email address
  and password, or sign in using Google. For email registration,
  we process your registration information to create your account
  and authenticate access. For Google sign-in, we receive your
  name and email address; we do not receive your Google password.
  Google processes information under its
  <a
    href="https://policies.google.com/privacy"
    target="_blank"
    rel="noopener noreferrer"
  >Privacy Policy</a>.
</li>
<li>
  <strong>AI:</strong>
  Emergent facilitates AI Coach processing through third-party
  AI services, including OpenAI. Your fitness goals, experience
  level, requested number of workout days, injury-prone areas
  and internal user ID are processed to generate personalised
  workout plans. Your name and email address are not included
  in those prompts.
</li>
</ul>
<p>We may disclose necessary information to comply with binding legal obligations, respond to valid legal process, investigate fraud or protect rights and safety where legally permitted. A genuine business restructuring or transfer may involve disclosure subject to applicable safeguards, notice and other legal requirements. This does not authorise unrelated reuse of your data.</p>
<p>
  We do not sell your personal data. We disclose personal data
  to the service providers identified in this Policy as needed
  to operate the Application, and for the legal purposes
  described above.
</p>
<h3>7. Advertising, tracking and future features</h3>
<p>AdMob is planned but is not part of the current service described by this draft. Before activating advertising, we will update this Policy to explain the actual SDK data, recipients, advertising purposes, retention, applicable choices and opt-outs, and obtain required consent before relevant processing begins. Future advertising is not authorised by this paragraph.</p>
<p>Photo uploads are also planned, rather than a current feature described here. Before collection begins, we will explain the purposes, access, storage, retention, deletion and relevant permissions, and obtain consent where required. New purposes such as publicity or AI training require their own lawful assessment and any necessary consent; uploading a photo will not itself authorise every future use.</p>
<p>
  We do not currently use analytics or advertising tracking
  tools to monitor your behaviour. We use account identifiers
  and authentication tokens to recognise your account,
  maintain login sessions and provide the Application.
</p>
<h3>8. Storage and international processing</h3>
<p>We operate from India and use Emergent-managed hosting and MongoDB Atlas to operate the Application and store its data. Their hosting region depends on the production deployment configuration. Backup locations and the countries from which Emergent staff may access production data have not yet been confirmed.</p>
<p>Some personal data is processed outside India. Through Emergent's AI integration, OpenAI processes AI Coach inputs in the United States, including your fitness goals, experience level, requested training days, any injury information you choose to provide, and your internal Muscle Up user ID. Your name and email address are not included in those prompts. RevenueCat processes user identifiers and subscription transaction information in the United States. Password-reset emails are processed through an AWS-based service in the United States. Google sign-in involves Google's global infrastructure and Emergent's authentication service.</p>
<p>Your data may therefore be processed outside your country of residence, where data protection laws may differ. Depending on your location, this may involve international transfers. For questions about international processing, contact <a href="mailto:srushtee@universedecoder.in">srushtee@universedecoder.in</a>.</p>
<h3>9. Retention</h3>
<p>We retain personal data only for the disclosed purposes and applicable lawful requirements. Retention depends on the data category, whether the account remains active, legal requirements, security needs and any specific dispute or legal hold. Our verified schedule is:</p>
<ul>
  <li>
    <strong>Account, goal and workout records:</strong>
    We store account information, workout history, weekly plans
    and AI Coach plan history to provide your account and related
    features. You can request deletion through the Application
    or by emailing srushtee@universedecoder.in.
  </li>

  <li>
    <strong>Authentication and security records:</strong>
    We store password hashes, login session tokens and hashed
    password-reset tokens to support authentication and account
    recovery. Their retention periods are being confirmed.
  </li>

  <li>
    <strong>Subscription records:</strong>
    We store subscription-related information and RevenueCat
    subscription events to manage paid access and resolve
    purchase issues. Google Play processes payments.
    We do not receive payment-card or bank-account details.
    The applicable retention periods are being confirmed.
  </li>

  <li>
    <strong>Support and deletion requests:</strong>
    We process information you provide when contacting us
    or requesting deletion. Account-deletion feedback is stored
    without an attached user ID or email address. Retention
    periods for these records are being confirmed.
  </li>

  <li>
    <strong>Backups and AI-provider copies:</strong>
    Backup expiry periods, AI-provider retention periods and
    the handling of individual deletion requests across these
    services are being confirmed.
  </li>
</ul>
<p>Where retention is necessary after account deletion, we limit it to the relevant records and purpose. Backup copies pending scheduled expiry are restricted from ordinary use.</p>
<h3>10. Account and data deletion</h3>
<p>You can request account deletion through the App's account deletion option or email <a href="mailto:srushtee@universedecoder.in?subject=Muscle%20Up%20account%20deletion">srushtee@universedecoder.in</a> with “Muscle Up account deletion” in the subject. Send the request from your registered email where possible. You do not need to reinstall the App to use the email route.</p>
<p>Uninstalling alone does not delete server data. Account deletion can end access to stored workouts and paid features. Google Play subscription cancellation is separate: cancel renewal through Google Play as well; you can request deletion without cancelling first. Google may retain its own payment records under its separate obligations.</p>
<h3>11. Your privacy rights and choices</h3>
<p>Depending on applicable law, you may have rights to access your data and information about its use, correct it, request erasure or a portable copy, restrict processing, object to certain processing, withdraw consent and challenge qualifying automated decisions. Where applicable, you may also have Indian statutory grievance and nomination rights as the relevant provisions take effect. Rights have legal conditions and exceptions; this Policy does not bring a law into force before its commencement.</p>
<p>Contact us at the email above. We will respond within the deadline applicable to your request, verify identity proportionately and explain any lawful refusal or extension. An authorised representative may act where law permits, subject to appropriate verification. We will not unlawfully discriminate against you for exercising rights.</p>
<p>If EEA or UK data protection law applies, you may also complain to your competent supervisory authority and object to processing based on legitimate interests, subject to legal conditions. Where applicable US state privacy or consumer-health laws provide additional access, deletion, appeal, consent, sale/sharing or targeted-advertising rights, those rights remain available.</p>
<p>Optional marketing will offer an unsubscribe mechanism if introduced. Service, security and legally required communications may continue as necessary. Device permissions can be managed through your operating-system settings; withdrawing a permission does not automatically delete data already stored.</p>
<h3>12. Security and incidents</h3>
<p>
  We use password hashing for email-based accounts, hashed
  password-reset tokens and session-based authentication
  to help protect access to user accounts. Hosting and
  database services are provided through Emergent and
  MongoDB Atlas.
</p>

<p>
  No online system can guarantee absolute security.
  If a personal data breach requires notification under
  applicable law, we will notify affected users and the
  relevant authorities as required.
</p>
<h3>13. Adults only</h3>
<p>The App is intended only for adults aged 18 and over, or any higher age needed to contract independently under applicable law. We do not knowingly offer it to children or seek their data. If you believe a child has provided data, contact us so we can investigate, restrict the account and delete information as required. </p>
<h3>14. Changes and contact</h3>
<p>We will display an updated effective date when this Policy changes. Material changes will receive appropriate notice in the App or by email, and new consent will be obtained where required before new processing begins. We will not treat continued use as consent where affirmative consent is required.</p>
<p>For privacy questions, complaints or requests, email srushtee@universedecoder.in or write to the verified business address in section 1. You may also use any applicable regulator or statutory grievance route without first waiving other remedies.</p>

`;

const PrivacyPolicy = () => (
  <main className="privacy-policy">
    <div className="privacy-policy-container">
      <header className="privacy-policy-header">
        <BackToHome />
        <div className="privacy-policy-eyebrow">
          <span className="privacy-policy-dot" />
          YOUR DATA. YOUR RIGHTS.
        </div>
        <h1>
          PRIVACY
          <br />
          <span>POLICY.</span>
        </h1>
        <p className="privacy-policy-description">
          How Muscle Up collects, uses and handles your information.
        </p>
        <div className="privacy-policy-meta">
          <span>UNIVERSEDECODER</span>
          <span>DRAFT — VERIFY BEFORE PUBLICATION</span>
        </div>
      </header>
      <div className="privacy-policy-body">
        <div
          className="privacy-policy-content"
          dangerouslySetInnerHTML={{ __html: privacyPolicy }}
        />
      </div>
      <footer className="privacy-policy-footer">
        <span>© {new Date().getFullYear()} MUSCLE UP</span>
        <span>BUILT FOR THE LONG GAME.</span>
      </footer>
    </div>
  </main>
);

export default PrivacyPolicy;
